import { render, staticRenderFns } from "./upload-image-cropper.vue?vue&type=template&id=198a6e2c"
import script from "./upload-image-cropper.vue?vue&type=script&lang=ts"
export * from "./upload-image-cropper.vue?vue&type=script&lang=ts"
import style0 from "./upload-image-cropper.vue?vue&type=style&index=0&id=198a6e2c&prod&module=true&lang=stylus"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports